import { api } from './api';
import type { ApiResponse } from '../utils/types';
import { toast } from 'sonner';
import { Notification } from '../store/notificationStore';


const API_ENDPOINTS = {
    notifications: '/notifications',
    markAsRead: (id: string) => `/notifications/read/${id}`,
};

function isErrorWithResponse(error: unknown): error is { response?: { status?: number; data?: { message?: string } } } {
    return typeof error === 'object' && error !== null && 'response' in error;
}

export class NotificationService {
    async getUserNotifications(): Promise<Notification[]> {
        try {
            const response = await api.get<ApiResponse<Notification[]>>(API_ENDPOINTS.notifications);
            if (!response.data.success) throw new Error(response.data.message || 'Failed to fetch notifications');
            return response.data.data.map(n => ({ ...n, id:  n._id }));
        } catch (error) {
            console.error('Failed to fetch notifications:', error);
            throw new Error('Failed to fetch notifications. Please try again.');
        }
    }

    async markAsRead(notificationId: string): Promise<void> {
        try {
            const response = await api.patch<ApiResponse<void>>(API_ENDPOINTS.markAsRead(notificationId));
            if (!response.data.success) throw new Error(response.data.message || 'Failed to mark notification as read');
        } catch (error) {
            console.error('Failed to mark notification as read:', error);
            let message = 'Failed to mark notification as read. Please try again.';
            if (isErrorWithResponse(error)) {
                if (error.response?.status === 404) message = 'Notification not found';
                else if (error.response?.data?.message) message = error.response.data.message;
            }
            toast.error(message);
            throw new Error(message);
        }
    }
}

// Singleton instance
export const notificationService = new NotificationService();
